import NumeroAnimado from '@/components/movimento/NumeroAnimado';
import type { ResumoPortaria } from '../types';

interface TopoNumerosProps {
  resumo: ResumoPortaria | null;
  eventoNome: string;
}

function Item({ rotulo, valor, destaque }: { rotulo: string; valor: number; destaque?: boolean }) {
  return (
    <div className="flex flex-col items-center px-2 py-3">
      <span
        className={`text-[10px] font-semibold uppercase tracking-[0.18em] ${
          destaque ? 'text-amber-400' : 'text-white/50'
        }`}
      >
        {rotulo}
      </span>
      <span className="mt-1 text-4xl font-bold tabular-nums leading-none text-white">
        <NumeroAnimado valor={String(valor)} />
      </span>
    </div>
  );
}

export default function TopoNumeros({ resumo, eventoNome }: TopoNumerosProps) {
  return (
    <div className="w-full shrink-0 border-b border-white/10 bg-black/40 px-3 py-2">
      <p className="truncate text-center text-xs font-medium text-white/70">{eventoNome}</p>
      <div className="mt-1 grid grid-cols-3">
        <Item rotulo="Entraram" valor={resumo?.ja_entraram ?? 0} />
        <Item rotulo="Faltam" valor={resumo?.ainda_nao_chegaram ?? 0} />
        <Item rotulo="Não pagos" valor={resumo?.pendentes_de_pagamento ?? 0} destaque />
      </div>
    </div>
  );
}